import { HttpLink, CombinedGraphQLErrors, ServerError } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { RetryLink } from "@apollo/client/link/retry";
import { setContext } from "@apollo/client/link/context";
import { notEmpty } from "@orb-labs/types";
import { ErrorEvents } from "../bullrun/analytics.js";
const REDACT_PATTERN = /(token|key|secret|password|credential)s?[:\s]*[^\s,}]*/gi;
export const createHttpLink = (baseUrl) => {
    return new HttpLink({ uri: baseUrl });
};
export const retryLink = new RetryLink({
    attempts: { max: 3 },
    delay: { initial: 500 },
});
export const createAuthLink = (getToken) => {
    return setContext(async (_operation, prevContext) => {
        const token = await getToken();
        const headers = prevContext.headers || {};
        return {
            headers: {
                ...headers,
                ...(token ? { authorization: `Bearer ${token}` } : {}),
            },
        };
    });
};
export const createErrorLink = (observability) => {
    return onError(({ error, operation }) => {
        const definition = operation.query.definitions[0];
        const isSubscription = definition?.kind === "OperationDefinition" && definition.operation === "subscription";
        if (isSubscription)
            return;
        if (CombinedGraphQLErrors.is(error)) {
            error.errors.forEach((err) => {
                if (observability.isDev) {
                    observability.error("[GraphQL error]:", err.message, err.path);
                }
            });
            observability.capture(ErrorEvents.API_ERROR, {
                operation_name: operation.operationName,
                error_count: error.errors.length,
                error_messages: error.errors.map((e) => e.message?.replace(REDACT_PATTERN, "[REDACTED]")),
            });
        }
        else if (error) {
            const statusCode = ServerError.is(error) ? error.statusCode : undefined;
            // Redact before logging AND capturing so tokens/keys embedded in a
            // network error message can't leak into either destination.
            const redactedMessage = notEmpty(error.message) ? error.message.replace(REDACT_PATTERN, "[REDACTED]") : undefined;
            const opName = operation.operationName || "unknown";
            const suffix = statusCode ? `, status: ${statusCode}` : "";
            observability.error(notEmpty(redactedMessage)
                ? `[Network error]: ${redactedMessage} (operation: ${opName}${suffix})`
                : `[Network error] (operation: ${opName}${suffix})`);
            observability.capture(ErrorEvents.NETWORK_ERROR, {
                operation_name: operation.operationName,
                error_message: redactedMessage,
            });
        }
    });
};
